interface Option {
	code: string;
	name: string;
	disabled?: boolean;
}

export default function formikOptions(
	options: Option[] = [],
): Array<{ value: string; label: string; disabled?: boolean }> {
	return options.map(o => ({ value: o.code, label: o.name, ...(o.disabled ? { disabled: true } : {}) }));
}
